import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import StartScreen from "./components/StartScreen";
import Game from "./components/Game";
import {
  Homepage,
  Games,
  Tokenomics,
  Buy,
  Swap,
  Stake,
  Validator,
  Memecollection,
  WhyReddicks,
  TreasuryPage,
  Charity,
  ImageCreator,
  Verify,
} from "./components/Home";
import Layout from "./dckslap/components/layout/Layout";
import MainLayout from "./components/Layout/MainLayout";
import "./styles/App.scss";
import ScrollToTop from "./components/Common/ScrollToTop";
import RouteSEO from "./components/Common/RouteSEO";
import ImageDirectPage from "./components/Common/HomepageCard/ImageDirectPage";
import NotFound from "./components/Common/NotFound";
import { isSwapHostname } from "./utils/hostRouting";

const RootLanding = () => (isSwapHostname() ? <Swap /> : <Homepage enableIntroFlow />);

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <RouteSEO />
      <div className="app-container">
        <div className="app">
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<RootLanding />} />
              <Route path="/home" element={<Homepage />} />
              <Route path="/game-info" element={<Games />} />
              <Route path="/tokenomics" element={<Tokenomics />} />
              <Route path="/buy" element={<Buy />} />
              <Route path="/swap" element={<Swap />} />
              <Route path="/verify" element={<Verify />} />
              <Route path="/start" element={<StartScreen />} />
              <Route path="/game/:saveId" element={<Game />} />
              <Route path="/stake" element={<Stake />} />
              <Route path="/validator" element={<Validator />} />
              <Route path="/memecollection" element={<Memecollection />} />
              <Route path="/whyreddicks" element={<WhyReddicks />} />
              <Route path="/charity" element={<Charity />} />
              <Route path="/image-creator" element={<ImageCreator />} />
              <Route path="/treasury" element={<TreasuryPage />} />
              <Route path="/live-card" element={<ImageDirectPage />} />
              <Route path="/live-card/card.png" element={<ImageDirectPage />} />
              <Route
                path="/.well-known/radix.json"
                element={
                  <Navigate
                    to={`${process.env.PUBLIC_URL}/.well-known/radix.json`}
                    replace
                  />
                }
              />
            </Route>
            <Route path="/dckslap" element={<Layout />} />
            <Route path="/dckslap/homepage" element={<Layout />} />
            <Route path="/dckslap/leaderboard" element={<Layout />} />
            <Route path="/dckslap/slapgenerator" element={<Layout />} />
            <Route path="/dckslap/sendslap" element={<Layout />} />
            <Route path="/dckslap/achievements" element={<Layout />} />
            <Route path="/dckslap/secret-machine" element={<Layout />} />
            <Route path="/dckslap/howtoplay" element={<Layout />} />
            <Route path="/dckslap/candyshop" element={<Layout />} />
            <Route path="/dckslap/candywrapper" element={<Layout />} />
            <Route path="/dckslap/viplounge" element={<Layout />} />
            <Route path="/dckslap/candycombiner" element={<Layout />} />
            <Route path="/dckslap/test-transaction" element={<Layout />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
